var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAttention = function SvgAttention(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.199 5.986a7.5 7.5 0 0 1 10.299 2.778l.002.004 19.99 34.983.002.004A7.5 7.5 0 0 1 50.002 55H10.01a7.5 7.5 0 0 1-6.553-11.245c0-.002.002-.004.003-.005L23.45 8.768l.003-.004a7.5 7.5 0 0 1 2.746-2.778Zm3.776 3.98a2.5 2.5 0 0 0-2.175 1.267l-.004.008L7.79 46.251A2.5 2.5 0 0 0 9.977 50h40.02a2.5 2.5 0 0 0 2.163-3.75l-.006-.01-20-35-.004-.008a2.5 2.5 0 0 0-2.175-1.267Z",
    fill: "#F22F22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 20a2.5 2.5 0 0 1 2.5 2.5v10a2.5 2.5 0 0 1-5 0v-10A2.5 2.5 0 0 1 30 20ZM27.5 42.5A2.5 2.5 0 0 1 30 40h.025a2.5 2.5 0 1 1 0 5H30a2.5 2.5 0 0 1-2.5-2.5Z",
    fill: "#000"
  })));
};
export default SvgAttention;